import React from 'react';
import ProjectsMenu from './ProjectsMenu';

export default function Projects() {
  return (
    <>
      <ProjectsMenu />
    </>
  );
}
